import { render } from "./NewSMSListForm.vue?vue&type=template&id=395f1ad0"
import script from "./NewSMSListForm.vue?vue&type=script&lang=js"
export * from "./NewSMSListForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__